module.exports = __webpack_public_path__ + "static/img/lebenor-text-1.98eaf2e.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/lebenor-text-1.png
// module id = 105
// module chunks = 0